import 'moment/locale/th'
import {
  getDate,
  getYear,
  getHours,
  getMinutes,
  getSeconds,
  getTime,
  add,
  format,
} from 'date-fns'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

export default class OverwriteStaticFnsBE extends AdapterDateFns {
  constructor({ locale, formats, instance }) {
    super({ locale, formats, instance })
  }

  format = (date, formatKey) => {
    let newDate = add(date, { years: 543 })

    switch (formatKey) {
      case 'year':
        return getYear(newDate)
      case 'dayOfMonth':
        return getDate(newDate)
      case 'monthShort':
        return format(newDate, 'LLLL', { locale: this.locale })
      case 'month':
        return format(newDate, 'LLLL', { locale: this.locale })
      case 'fullDate':
        return format(newDate, 'dd/MM/yyyy', { locale: this.locale })
      case 'monthAndYear':
        return format(newDate, 'LLLL yyyy', { locale: this.locale })
      case 'time':
        return getTime(newDate)
      case 'hours':
        return getHours(newDate)
      case 'minutes':
        return getMinutes(newDate)
      case 'seconds':
        return getSeconds(newDate)
      default:
        return ''
    }
  }
}
